module.exports = __webpack_public_path__ + "static/media/A7S01652.6b666be1.jpg";